import { makeStyles } from '@material-ui/core';

export default makeStyles({
  icon: {
    width: 16,
    height: 16,
  },
});
